import HelloKittyBride from '../assets/images/hellokitty_bride.webp';
import HelloKittyGroom from '../assets/images/hellokitty_groom.webp';
import LanguageToggle from './LanguageToggle';

export default function StoryHeader() {
  return (
    <header className="nav-topbar absolute top-0 left-0 right-0 z-50 shadow-sm">
      <div className="flex items-center pt-3 pb-2 px-4">
        <div className="flex flex-row">
          <img src={HelloKittyGroom} alt="Groom" className="max-w-9 max-h-9" />
          <img src={HelloKittyBride} alt="Bride" className="max-w-9 max-h-9" />
        </div>
        <h1 className="text-3xl text-top-title select-none flex-1 text-center">
          Daniel &amp; Tracer
        </h1>
        <LanguageToggle className="btn-language-toggle shrink-0 ml-2 mr-1" />
      </div>
    </header>
  );
}
